import { useState } from 'react';
import styled from 'styled-components';
import { Card, Tabs } from 'antd';
import { Market } from './Market';
import { History } from './History';

const TAB_ITEMS = [
  {
    key: 'market',
    label: 'Market',
  },
  {
    key: 'history',
    label: 'History',
  },
];

const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    color: #fff;
  }

  // .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  //   color: #333 !important;
  // }

  .ant-tabs-nav-operations {
    display: none !important;
  }
`;

const StyledCard = styled(Card)`
  .ant-card-body {
    max-height: calc(100vh - 140px);
    overflow-y: auto;
  }
`;

export const Trade = () => {
  const [activeKey, setActiveKey] = useState(TAB_ITEMS[0].key);

  const tabs = (
    <StyledTabs
      hideAdd
      type="card"
      size="small"
      items={TAB_ITEMS}
      activeKey={activeKey}
      onChange={key => setActiveKey(key)}
    />
  );

  return (
    <StyledCard size="small" title="Trade" extra={tabs}>
      {activeKey === TAB_ITEMS[0].key && <Market />}
      {activeKey === TAB_ITEMS[1].key && <History />}
    </StyledCard>
  );
};
